<template>
	<div class="safe" :style="{ paddingTop: top + 'px' }">
		<div class="safe-content">
			<BackButton v-if="showBackButton && closePosition !== 'left'" :theme="theme" @back-button-click="$emit('back')" />
			<Close v-if="showClose" :theme="theme" @close="$emit('close')" :position="closePosition" />
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from '@vue/reactivity'

import Close from './Close.vue'
import BackButton from './BackButton.vue'

export default {
	components: {
    Close,
    BackButton
},

	props: {
		theme: {
			type: String,
			default: 'primary'
		},
		showClose: {
			type: Boolean,
			default: true
		},
		closePosition: {
			type: String,
			default: 'right'
		},
		showBackButton: {
			type: Boolean,
			default: false
		}
	},

	setup() {
		const store = useStore()
		const top = computed(() => store.state.offset_top)

		return {
			top
		}
	}
}
</script>

<style lang="scss" scoped>
.safe {
	&-content {
		position: relative;
	}
}
</style>
